import anime from 'animejs'
import './big-cover-buttons.scss'

const selector = '.big-cover-button'
const spaceBarKeyCode = 32
const escButtonKeyCode = 27

const weakMap = new WeakMap()

class ButtonAnimation {
  constructor(el) {
    this.el = el
    weakMap.set(el, this)
    this.tl = anime.timeline({
      autoplay: false,
      easing: 'easeOutQuad',
    })
    // this.tl.add({
    //   targets: this.el.querySelector('.big-cover-button__button-animation'),
    //   translateX: ['0%', '-100%'],
    //   translateY: ['0%', '-100%'],
    //   duration: 800,
    // })
    this.tl.add(
      {
        targets: this.el.querySelectorAll('.big-cover-button__input'),
        opacity: [0, 1],
        duration: 400,
        delay: (target, i) => i * 100,
      },
      200
    )
    this.tl.add(
      {
        targets: this.el.querySelectorAll('.input-block'),
        translateY: ['2rem', '0rem'],
        duration: 400,
        delay: (target, i) => i * 100,
      },
      200
    )
    this.tl.add(
      {
        targets: this.el.querySelector('.big-cover-button__submit'),
        translateY: ['2rem', '0rem'],
        opacity: [0, 1],
        duration: 400,
      },
      800
    )
  }

  open() {
    this.el.classList.add('active')
    this.el.classList.remove('hidden')
    if (this.tl.reversed) {
      this.tl.reverse()
    }
    if (this.tl.progress < 99) {
      this.tl.play()
    }
  }

  close() {
    this.el.classList.remove('active')
    this.el.classList.add('hidden')
    if (!this.tl.reversed) {
      this.tl.reverse()
    }
    if (this.tl.progress > 0) {
      this.tl.play()
    }
  }

  idle() {
    this.el.classList.remove('active')
    this.el.classList.remove('hidden')
    if (!this.tl.reversed) {
      this.tl.reverse()
    }
    if (this.tl.progress > 0) {
      this.tl.play()
    }
  }
}

const bigCoverButtons = el => {
  const buttons = Array.from(el.querySelectorAll(selector))

  buttons.forEach(b => {
    new ButtonAnimation(b)

    const open = () => {
      buttons.forEach(button => {
        const animation = weakMap.get(button)
        if (animation) {
          if (b === button) {
            animation.open()
          } else {
            animation.close()
          }
        }
      })
    }

    const close = () => {
      buttons.forEach(button => {
        const animation = weakMap.get(button)
        if (animation) {
          animation.idle()
        }
      })
    }

    b.addEventListener('click', open)
    b.addEventListener('keydown', e => {
      if (e.keyCode === spaceBarKeyCode) {
        e.preventDefault()
        open()
      } else if (e.keyCode === escButtonKeyCode) {
        close()
      }
    })
    b.querySelector('.big-cover-button__close').addEventListener('click', e => {
      e.stopPropagation()
      close()
    })
  })
}

// close when clicked outside - disabled because of bugs with clicking on dropdown in number-input-with-suggestions

// document.documentElement.addEventListener('click', e => {
//   if (!e.target.closest(selector)) {
//     document.querySelectorAll(selector).forEach(b => {
//       const animation = weakMap.get(b)
//       if (animation) {
//         animation.idle()
//       }
//     })
//   }
// })

export default bigCoverButtons
